import { render, staticRenderFns } from "./ThaiQRPayLabel.vue?vue&type=template&id=4454dc7e&scoped=true&"
import script from "./ThaiQRPayLabel.vue?vue&type=script&lang=js&"
export * from "./ThaiQRPayLabel.vue?vue&type=script&lang=js&"
import style0 from "./ThaiQRPayLabel.vue?vue&type=style&index=0&id=4454dc7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4454dc7e",
  null
  
)

export default component.exports